import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ThreeDots } from 'react-loader-spinner';
import Backdrop from '@mui/material/Backdrop';

const styles = (/* theme */) =>
	({
		root :
		{
			height   : '100%',
			width    : '100%',
			position : 'fixed',
			zIndex   : 999,
			overFlow : 'hidden',
			margin   : 'auto',
			top      : '50%',
			left     : '47%'
		}
	});

const LoadingView = ({
	classes
}) =>
{
	return (
		<div className={classes.root}>
			<Backdrop
				open
				sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
			>
				<ThreeDots
					height='80'
					width='80'
					radius='9'
					color='green'
					ariaLabel='three-dots-loading'
				/>
			</Backdrop>
		</div>
	);
};

export default withStyles(styles)(LoadingView);
